// Import model
import { UpdateSelectionBinRequest } from '../models/UpdateSelectionBinRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateRoomSelectionRequest } from '../models/UpdateRoomSelectionRequest';

// Import dependency serializers (for complex types)
import { UpdateRoomSelectionRequestSerializer } from './UpdateRoomSelectionRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSelectionBinRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSelectionBinRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSelectionBinRequest instance
   */
  static deserialize(json: string): UpdateSelectionBinRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSelectionBinRequest instance
   */
  static fromObject(obj: any): UpdateSelectionBinRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSelectionBinRequest');
    }


    const instance: UpdateSelectionBinRequest = {
      description: obj['description'] as string | undefined,
      itemIds: obj['itemIds'] ? (obj['itemIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      roomSelection: obj['roomSelection'] ? UpdateRoomSelectionRequestSerializer.fromObject(obj['roomSelection']) : undefined as any,
      rooms: obj['rooms'] ? (obj['rooms'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSelectionBinRequest instances
   */
  static deserializeArray(json: string): UpdateSelectionBinRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSelectionBinRequest instance to a JSON string
   */
  static serialize(instance: UpdateSelectionBinRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSelectionBinRequest instance to a plain object
   */
  static toObject(instance: UpdateSelectionBinRequest): any {
    return {
      'description': instance.description,
      'itemIds': instance.itemIds?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'roomSelection': instance.roomSelection ? UpdateRoomSelectionRequestSerializer.toObject(instance.roomSelection) : undefined,
      'rooms': instance.rooms?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of UpdateSelectionBinRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSelectionBinRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
